const appRoutes=[
  {
    path: '/dashboard',
    name: 'CustomerDashboard',
    component: () => import('../views/Customer/CustomerDashboardView.vue'),
    meta: { requiresCustomer: true }
  },
  {
    path: '/reconciliation/uploads',
    name: 'CustomerUploadCenter',
    component: () => import('../views/Customer/CustomerUploadCenterView.vue'),
    meta: { requiresCustomer: true }
  },
  {
    path: '/reconciliation/runs',
    name: 'CustomerReconciliationRuns',
    component: () => import('../views/Customer/CustomerReconciliationRunsView.vue'),
    meta: { requiresCustomer: true }
  },
  {
    path: '/reconciliation/reports',
    name: 'CustomerReconciliationReports',
    component: () => import('../views/Customer/CustomerReconciliationReportsView.vue'),
    meta: { requiresCustomer: true }
  },
  {
    path: '/reconciliation/mapping',
    name: 'CustomerReconciliationMapping',
    component: () => import('../views/Customer/CustomerReconciliationMappingView.vue'),
    meta: { requiresCustomer: true }
  },
  {
    path: '/subscriptions',
    name: 'CustomerSubscriptions',
    component: () => import('../views/Customer/CustomerSubscriptionsView.vue'),
    meta: { requiresCustomer: true, requiresCompanyAdmin: true }
  },
  {
    path: '/reconciler/billing',
    name: 'CustomerBillingPortal',
    component: () => import('../views/Customer/CustomerSubscriptionsView.vue'),
    meta: { requiresCustomer: true, requiresCompanyAdmin: true }
  },
  {
    path: '/reconciler/billing/mpesa-checkout',
    name: 'CustomerMpesaCheckout',
    component: () => import('../views/Customer/Billing/CustomerMpesaCheckoutView.vue'),
    meta: { requiresCustomer: true, requiresCompanyAdmin: true }
  },
  {
    path: '/reconciler/billing/documents/:documentId',
    name: 'CustomerBillingDocument',
    component: () => import('../views/Customer/Billing/BillingDocumentView.vue'),
    meta: { requiresCustomer: true, requiresCompanyAdmin: true }
  },
  {
    path: '/subscriptions/success',
    redirect: '/subscriptions',
    meta: { requiresCustomer: true, requiresCompanyAdmin: true }
  },
  {
    path: '/subscriptions/canceled',
    redirect: '/subscriptions',
    meta: { requiresCustomer: true, requiresCompanyAdmin: true }
  },
  {
    path: '/company/staff',
    name: 'CustomerCompanyStaff',
    component: () => import('../views/Customer/Staff/StaffIndexView.vue'),
    meta: { requiresCustomer: true, requiresCompanyAdmin: true }
  },
  {
    path: '/company/staff/new',
    name: 'CustomerCompanyStaffNew',
    component: () => import('../views/Customer/Staff/StaffFormView.vue'),
    meta: { requiresCustomer: true, requiresCompanyAdmin: true }
  },
  {
    path: '/company/staff/:id/edit',
    name: 'CustomerCompanyStaffEdit',
    component: () => import('../views/Customer/Staff/StaffFormView.vue'),
    meta: { requiresCustomer: true, requiresCompanyAdmin: true }
  },
  {
    path: '/super-admin',
    name: 'SuperAdminDashboard',
    component: () => import('../views/SuperAdmin/SuperAdminDashboardView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/subscriptions',
    name: 'SuperAdminSubscriptions',
    component: () => import('../views/SuperAdmin/SuperAdminSubscriptionsView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/payment-hub',
    name: 'SuperAdminPaymentHub',
    component: () => import('../views/SuperAdmin/Billing/PaymentHubView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/catalog-health',
    name: 'SuperAdminCatalogHealth',
    component: () => import('../views/SuperAdmin/SuperAdminCatalogHealthView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/ai-usage',
    name: 'SuperAdminAiUsage',
    component: () => import('../views/SuperAdmin/SuperAdminAiUsageView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/storage-usage',
    name: 'SuperAdminStorageUsage',
    component: () => import('../views/SuperAdmin/SuperAdminStorageUsageView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/subscriptions/:id/edit',
    name: 'SuperAdminSubscriptionEdit',
    component: () => import('../views/SuperAdmin/SuperAdminSubscriptionEditView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/activity-logs',
    name: 'SuperAdminActivityLogs',
    component: () => import('../views/SuperAdmin/SuperAdminActivityLogsView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/products',
    name: 'SuperAdminProducts',
    component: () => import('../views/SuperAdmin/SuperAdminProductsView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/plans',
    name: 'SuperAdminPlans',
    component: () => import('../views/SuperAdmin/SuperAdminPlansView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/customers',
    name: 'SuperAdminCustomers',
    redirect: '/super-admin/companies',
  },
  {
    path: '/super-admin/companies',
    name: 'SuperAdminCompanies',
    component: () => import('../views/SuperAdmin/Companies/CompaniesIndexView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/companies/new',
    name: 'SuperAdminCompaniesNew',
    component: () => import('../views/SuperAdmin/Companies/CompanyFormView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/companies/:id/edit',
    name: 'SuperAdminCompaniesEdit',
    component: () => import('../views/SuperAdmin/Companies/CompanyFormView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/staff',
    name: 'SuperAdminStaff',
    component: () => import('../views/SuperAdmin/Staff/StaffIndexView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/staff/new',
    name: 'SuperAdminStaffNew',
    component: () => import('../views/SuperAdmin/Staff/StaffFormView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/staff/:id/edit',
    name: 'SuperAdminStaffEdit',
    component: () => import('../views/SuperAdmin/Staff/StaffFormView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/organization-setup',
    name: 'SuperAdminOrganizationSetup',
    component: () => import('../views/SuperAdmin/SuperAdminOrganizationSetupView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../views/Profile/ProfileView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/roles',
    name: 'Roles',
    component: () => import('../views/rbac/Roles.vue')
  },
  {
    path: '/permissions',
    name: 'Permissions',
    component: () => import('../views/rbac/Permissions.vue')
  },
  {
    path: '/users/access',
    name: 'UserAccess',
    component: () => import('../views/rbac/UserAccess.vue')
  }
];

export default appRoutes;
